<template>
    <div :class="{ drop: true, show: dropShown }" v-click-outside="onClickOutsideOfMenu">
        <a @click="showDrop" href="javascript:{}"><span :class="icon_class"></span></a>
        <div class="drop-content">
            <ul>
                <li v-for="opt in sortedOptions">
                    <a @click="selectOption(opt.value)" href="javascript:{}">{{ opt.label }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
    name: "icon-dropdown",
    props: ["options", "icon_class"],
    mounted() {},
    data() {
        return {
            dropShown: false,
            selected: null
        };
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        sortedOptions() {
            return this.options.sort(function(a, b) {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            });
        },
        selectedLabel() {
            var result = this.options.find(obj => {
                return obj.value === this.selected;
            });
            return result.label;
        }
    },
    methods: {
        onClickOutsideOfMenu(event) {
            if (this.dropShown) {
                this.dropShown = false;
            }
        },
        clickAway(event) {
            if (!event.currentTarget.contains(event.relatedTarget)) {
                this.dropShown = false;
            }
        },
        selectOption(value) {
            this.dropShown = false;
            this.selected = value;
            this.$emit("selected", { label: this.selectedLabel, value: this.selected });
        },
        showDrop() {
            this.dropShown = !this.dropShown;
        }
    }
};
</script>

<style scoped></style>
